import { AsyncDeleteViewModal } from 'svh-workspace-ui-lib/code-splitting/public';
import { jsx as _jsx } from "react/jsx-runtime";
export const DeleteCustomViewModal = ({
  customView,
  onConfirm,
  onReject,
  onSuccess
}) => {
  return /*#__PURE__*/_jsx(AsyncDeleteViewModal, {
    customView: customView,
    onConfirm: onConfirm,
    onReject: onReject,
    onSuccess: onSuccess
  });
};
DeleteCustomViewModal.displayName = 'DeleteCustomViewModal';